import React, { useEffect, useRef, useState } from "react";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  formatDate,
  formatDateMonth,
  noDataFound,
  getCurrentFinancialYear,
} from "../../../CommonMethhods/CommonMethods";
import {
  Client_Search,
  MFReports,
  MutualFund,
} from "../../../Configuration/API_URL";
import LoaderForSearch from "../../../Components/Common/LoaderForSearch";
import Loader from "../../../Components/Common/Loader";
import { toast } from "react-toastify";
import moment from "moment";
import SmallLoader from "../../../Components/Common/smallLoader";
import MFDuration from "../../MFReports/MFDuration";
import MFTransactionHistoryReportTable from "../../../Components/ReportTables/MFTransactionHistoryReportTable";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

export default function MFTransactionHistoryReportNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState();
  const [offset, setOffset] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
  const [customShow, setCustomShow] = useState(false);
  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const tableBodyRef = useRef(null);
  const calanderIcon = true;

  const clientCode = localStorage.getItem("clientCode");

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  useEffect(() => {
    getTransactionHistoryReport("grid", 1);
  }, []);

  const getTransactionHistoryReport = async (fileView, offsetTab) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }

    if (fileView === "grid" && offsetTab <= 1) {
      setLoader(true);
    }

    let payloadValue = {
      userId: clientCode,
      fileType: fileView,
      pageNo: fileView === "grid" ? offsetTab : -1,
      pageSize: fileView === "grid" ? 10 : -1,
      fromDate,
      endDate: toDate,
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        MFReports.Transaction_History,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setDataCount(res?.data?.totalCount);
          if (offsetTab > 1) {
            setTableData((prev) => {
              return [...prev, ...res?.data?.transactionHistList];
            });
          } else {
            setTableData(res?.data?.transactionHistList);
          }
          setScrollLoaderTable(false);
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setTableData([]);
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
    }
  };

  const handleFromDateChange = (e) => {
    //setTableData([]);
    setFromDateError(false);
    setErrorGrid(false);
    setFromDate(e.target.value);
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    //setTableData([]);
    setToDateError(false);
    setErrorGrid(false);
    setToDate(e.target.value);
    setServerError(false);
    setFromDateError(false);
  };

  const handleOnClick = (e) => {
    setOffset(1);

    if (customShow) {
      if (!fromDate) {
        setFromDateError("Please enter From Date");
        setTableData([]);
        return;
      }

      if (!toDate) {
        setToDateError("Please Enter To Date");
        setTableData([]);
        return;
      }

      if (!checkDateRange(fromDate, toDate)) {
        setFromDateError("Please Enter Correct Dates");
        setTableData([]);
        return;
      }

      setFromDateError(false);
      setToDateError(false);
    }

    // Valid case
    getTransactionHistoryReport(e.target.value, 1);
  };

  const handleTableScroll = (e) => {
    console.log("entered");
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoaderTable) {
      const nextOffset = offset + 1;
      const totalLoadedRecords = offset * 10;

      if (dataCount > totalLoadedRecords && dataCount !== tableData.length) {
        setOffset(nextOffset); // This still updates state for future reference
        setScrollLoaderTable(true);
        setLoader(false);
        getTransactionHistoryReport("grid", nextOffset);
      } else {
        setScrollLoaderTable(false);
      }
    }
  };

  useEffect(() => {
    const el = tableBodyRef.current;

    if (!el) return;

    const checkScroll = () => {
      setHasVerticalScroll(el.scrollHeight > el.clientHeight);
    };

    checkScroll();

    const observer = new ResizeObserver(checkScroll);
    observer.observe(el);

    return () => observer.disconnect();
  }, [tableData]);

  return (
    <>
      <div
        className="tab-pane fade show active mb-4"
        id="trade-summary"
        role="tabpanel"
        aria-labelledby="trade-summary"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group">
                  <MFDuration
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    className="report-custom-select"
                    setToDateError={setToDateError}
                    setFromDateError={setFromDateError}
                  />
                </div>

                {customShow && (
                  <div className="form-group calendar-icon">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      placeholder="DD/MM/YYYY"
                      className="datepicker form-control"
                      id="FromDateCombine"
                      onChange={handleFromDateChange}
                      max={DateReverse}
                    />
                    {fromDateError && (
                      <span className="dashboard-to-date-error">
                        {fromDateError}
                      </span>
                    )}
                  </div>
                )}
                {customShow && (
                  <div className="form-group calendar-icon">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      placeholder="DD/MM/YYYY"
                      className="datepicker form-control"
                      id="FromDateCombine"
                      onChange={handleToDateChange}
                      max={DateReverse}
                    />
                    {toDateError && (
                      <span
                        className="dashboard-to-date-error"
                        style={{ right: 0 }}
                      >
                        {toDateError}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {Constants.Submit}
            </button>
          </div>
          <div className="report-btn-wrapper">
            <button
              className="generate-button excel-btn"
              value="excel"
              onClick={handleOnClick}
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      <div
        className={`mutualfund-table ${
          tableData?.length == 0 ? "nodatawrapper" : ""
        }`}
      >
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : tableData && tableData.length > 0 ? (
          <div className="scroll-table master_table mutualfundTab">
            {tableData && tableData?.length > 0 ? (
              <MFTransactionHistoryReportTable
                tableData={tableData}
                handleTableScroll={handleTableScroll}
                hasVerticalScroll={hasVerticalScroll}
                scrollLoaderTable={scrollLoaderTable}
                loader={loader}
                LoaderForSearch={LoaderForSearch}
                ref={tableBodyRef}
                clientDashboard={true}
              />
            ) : (
              noDataFound()
            )}
          </div>
        ) : serverError ? (
          <h4 className="report-error-message">{noDataFound(serverError)}</h4>
        ) : errorGrid ? (
          noDataFound(errorGrid)
        ) : (
          ""
        )}
      </div>
    </>
  );
}
